import { render, staticRenderFns } from "./TypeExpeditionStatus.vue?vue&type=template&id=f8611fa2&"
import script from "./TypeExpeditionStatus.vue?vue&type=script&lang=js&"
export * from "./TypeExpeditionStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports